import React from 'react';
import { Button } from './Button';

interface CustomerTileProps {
  phone: string;
  company?: string;
  contactName?: string;
  onEdit?: () => void;
  className?: string;
}

export const CustomerTile: React.FC<CustomerTileProps> = ({
  phone,
  company,
  contactName,
  onEdit,
  className = ''
}) => {
  return (
    <div
      className={`border-b border-border flex flex-col gap-5 items-start px-0 py-3 w-full ${className}`}
      data-name="tile"
      data-node-id="17:1547"
    >
      <div
        className="flex gap-5 items-start w-full rounded-lg px-2 py-2"
        data-name="este contenido debería ser la información de cada chat, como en whatsapp que se muestra un vistazo truncado del último mensaje de la ocnversación"
      >
        <div className="flex-1 flex flex-col gap-2 items-start min-w-0">
          <div className="flex flex-col font-sans font-medium items-start leading-[1.4] w-full">
            <p className="text-base text-text tracking-[-0.16px] w-full truncate">
              {phone}
            </p>
            {company && (
              <p className="text-sm text-text-subtle tracking-[-0.14px] w-full truncate">
                {company}
              </p>
            )}
            {contactName && (
              <p className="text-sm text-text-subtle tracking-[-0.14px] w-full truncate">
                {contactName}
              </p>
            )}
          </div>
        </div>
        <div className="flex flex-col gap-2 items-end shrink-0">
          {onEdit && (
            <Button
              variant="ghost"
              onClick={(e) => {
                e.stopPropagation();
                onEdit();
              }}
            >
              Editar
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomerTile;

